// @core/api/endpoints/platform/list_platforms.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPlatformsResponse,
} from '../../../types/platform';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/platform';

/**
 * List platforms
 * Returns a paginated list of platforms the current user is a member of. Supports filtering by status and search by name or slug.
 */
export async function ListPlatforms(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPlatformsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/platforms`;
  const requestOptions = options;
  return client.get<ListPlatformsResponse>(requestPath, { ...requestOptions, params });
}
